var $2006053c58f5ea3d$exports = {};
$2006053c58f5ea3d$exports = {
    "collectionLabel": `Empfehlungen`
};


export {$2006053c58f5ea3d$exports as default};
//# sourceMappingURL=de-DE.mjs.map
